import script from "./DeliveryTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryTemplate.vue?vue&type=style&index=0&id=10d1a0ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d1a0ba"]])

export default __exports__